module.exports = __webpack_public_path__ + "static/media/undraw_Firmware_re_fgdy.9c174742.png";